import { render, staticRenderFns } from "./UsersModal.vue?vue&type=template&id=3af6be03&scoped=true&"
import script from "./UsersModal.vue?vue&type=script&lang=ts&"
export * from "./UsersModal.vue?vue&type=script&lang=ts&"
import style0 from "./UsersModal.vue?vue&type=style&index=0&id=3af6be03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af6be03",
  null
  
)

export default component.exports